import React, { FC } from 'react';
import { IMaskInput } from 'react-imask';
import { TextField, TextFieldProps } from '../textField';

type IMaskProps = {
  onChange: (event: {
    target: {
      name: unknown;
      value: unknown;
    };
  }) => void;
} & TextMaskProps;

const TextMask = React.forwardRef<HTMLElement, IMaskProps>(function TextMask(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      onAccept={(value: unknown) => onChange?.({ target: { name: props.name, value } })}
      inputRef={ref}
    />
  );
});

// Should be used from the package react-imask, after their typings are fixed
type TextMaskProps = {
  mask: unknown;
  definitions?: Record<string, unknown>;
  [key: string]: unknown;
};

type Props = TextFieldProps & {
  maskProps: TextMaskProps;
};
export type MaskedTextFieldProps = Props;

/**
 * MaskedTextField adds mask functionality to the TextField.
 *
 * The mask specific props can be passed by using maskProps. See
 * i-mask documentation for available options.
 *
 * Please use the NumberField if you want to mask numeric only values.
 */
export const MaskedTextField: FC<Props> = ({ maskProps, ...otherProps }) => {
  return <TextField {...otherProps} inputComponent={TextMask} inputProps={maskProps} />;
};
